var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadMobile = function SvgDownloadMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F6F8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h30v30H9z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#696F7F",
    strokeLinecap: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24.5v11"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m19.5 30.5 4.5 5 4.5-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 19c3.314 0 6.5 2.5 6.5 6.345 0 2.147-1.05 4.039-2.648 5.155L30.5 19Zm-13 0-3.883 11.478c-1.58-1.119-2.617-3-2.617-5.133C11 21.5 14.186 19 17.5 19Zm6.5-6.5c3.517 0 6.367 2.908 6.367 6.496H17.633c0-3.588 2.85-6.496 6.367-6.496Z"
  })))));
};
export default SvgDownloadMobile;